import StackTrace from 'stacktrace-js';

import { useAuthStore } from '@/store/authStore';

import { logServiceClient } from './api';

export default class LogService {
    static async info(message: string) {
        console.log('LogService info', message);
        return await this.log(message, 'info');
    }
    static async warn(message: string) {
        return await this.log(message, 'warn');
    }
    static async error(message: string) {
        return await this.log(message, 'error');
    }
    static async log(message: string, level = 'info') {
        console.log('LogService logger', message, level);

        // Ensure we have tokens before we try go call the LogService api.
        const authStore = useAuthStore();
        if (!authStore.ensureAuthTokens()) {
            console.warn('LogService: No access token found');
            return false;
        }
        const userProfile = authStore.getUserProfile();

        // Get stack trace
        let stackTrace: StackTrace.StackFrame[] = [];
        try {
            const error = new Error('BOOM!');
            stackTrace = await StackTrace.fromError(error);
        } catch (err) {
            console.info('LogService StackTrace.fromError failed:', err);
        }
        const payload = {
            message: message,
            level: level,
            user_id: userProfile.id,
            user_email: userProfile.email,
            user_name: userProfile.username,
            stack_trace: stackTrace,
            version: window.swVersion || 'unknown',
        };
        console.log('LogService(payload)', payload);

        const response = await logServiceClient.post('/logservice/log', payload);
        console.log('LogService response', response);
        if (response.status !== 200) {
            console.error('Failed to log message', message);
            return false;
        } else {
            console.log('LogService message', message);
            return true;
        }
    }

    /**
     * Retrieves logs for the current user with optional pagination.
     *
     * @param limit - Maximum number of items to retrieve (optional, defaults to 10 on the backend)
     * @param lastEvaluatedKey - Pagination token from a previous response (optional)
     * @returns An object with:
     *           - logs: Array of log entries,
     *           - last_evaluated_key: Pagination token (if available),
     *           - total_count: Total number of log entries for the user.
     */
    static async get(user_id: string, limit?: number, lastEvaluatedKey?: string) {
        const params: any = {
            user_id: user_id,
        };

        if (limit) {
            params.limit = limit;
        }

        if (lastEvaluatedKey) {
            params.last_evaluated_key = lastEvaluatedKey;
        }

        console.log('Fetching logs with params', params);
        const response = await logServiceClient.get('/logservice/get', { params });
        console.log('Get logs response', response);
        return response.data;
    }
}
